import React from "react";

const mainStyle = { fontSize: "9px", color: "#9b9a9a", paddingTop: 2 };
const linkStyle = { fontSize: "9px", color: "#81bae5" };

/**
 * Upsolver terms of service
 */
export function UpsolverLegal() {
  return (
    <div style={mainStyle}>
      By clicking "SIGN UP", you agree to the
      <a style={linkStyle} href="https://www.upsolver.com/privacy-policy">
        {" "}
        Privacy Policy
      </a>{" "}
      and End-user License Agreement.
    </div>
  );
}
